import React, { useState } from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';

const InquiryModal = ({ isOpen, onClose, eventTitle, organizationName, onSubmit }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    onSubmit(message);
    setMessage('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-modal">
      <div className="absolute inset-0 bg-secondary" onClick={onClose} />

      <div className="absolute bottom-0 left-0 right-0 md:relative md:flex md:items-center md:justify-center md:min-h-screen md:p-6">
        <div
          className="bg-card rounded-t-xl md:rounded-xl shadow-elevation-5 max-h-[85vh] md:max-h-[80vh] overflow-y-auto md:w-full md:max-w-lg"
          style={{ paddingBottom: 'env(safe-area-inset-bottom, 16px)' }}
        >
          <div className="flex items-center justify-between px-6 py-4 border-b border-border sticky top-0 bg-card">
            <h3 className="text-lg font-semibold font-heading text-foreground">문의하기</h3>
            <button
              onClick={onClose}
              className="flex items-center justify-center w-10 h-10 rounded-lg text-muted-foreground hover:bg-muted transition-smooth touch-target"
              aria-label="닫기"
              type="button"
            >
              <Icon name="XMarkIcon" size={24} />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-6">
            <div>
              <h4 className="text-base font-semibold text-foreground mb-1">{eventTitle}</h4>
              <p className="text-sm text-muted-foreground caption">{organizationName}</p>
            </div>

            <div className="p-4 rounded-lg bg-muted">
              <div className="flex items-start gap-3">
                <Icon name="InformationCircleIcon" size={20} className="text-primary mt-0.5" />
                <div className="flex-1">
                  <p className="text-sm text-foreground font-medium mb-1">문의 안내</p>
                  <p className="text-xs text-muted-foreground caption">
                    주최자에게 카카오톡 알림이 전송됩니다. 빠른 답변을 받으실 수 있습니다.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <label htmlFor="inquiry-message" className="block text-sm font-semibold text-foreground mb-3 caption">
                문의 내용 <span className="text-error">*</span>
              </label>
              <textarea
                id="inquiry-message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="궁금한 내용을 입력해주세요\n예: 주차 가능한가요? 준비물이 있나요?"
                rows={6}
                maxLength={500}
                className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth resize-none"
              />
              <p className="text-xs text-muted-foreground caption mt-2">{message.length}/500자</p>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 px-6 py-3 rounded-lg border border-border text-foreground hover:bg-muted transition-smooth touch-target font-medium"
              >
                취소
              </button>
              <button
                type="submit"
                disabled={!message.trim()}
                className={`flex-1 px-6 py-3 rounded-lg font-medium transition-smooth touch-target ${
                  message.trim()
                    ? 'bg-primary text-primary-foreground hover:shadow-elevation-2 active:scale-97'
                    : 'bg-muted text-muted-foreground cursor-not-allowed'
                }`}
              >
                문의 보내기
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default InquiryModal;
